/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { Pressable, Icon } from '@components/atoms'

import { grey, blue } from '@mui/material/colors'

interface PropsType {
	checked: boolean
	className?: string
	disabled?: boolean
	onClick?: () => void
	activeColor?: string
	style?: React.CSSProperties
}

export const CheckIconButton = (props: PropsType) => {
	const onClick = () => {
		if (props.onClick) {
			props.onClick()
		}
	}

	const activeColor: string =
		props.activeColor !== undefined ? props.activeColor : blue['A400']

	return (
		<Pressable
			onClick={onClick}
			css={[
				style,
				{ ...props.style },
				props.checked
					? { borderColor: activeColor, background: activeColor }
					: { borderColor: grey[300] },
				props.disabled
					? {
							background: grey[400],
							borderColor: grey[300],
					  }
					: null,
			]}
			className={props.className}
			disabled={props.disabled}
		>
			<Icon
				name="check-bold"
				css={[
					props.checked ? { color: '#FFF' } : { color: grey[300] },
					props.disabled ? { color: grey[300] } : {},
				]}
			/>
		</Pressable>
	)
}

const style = css({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	width: '1.5rem',
	height: '1.5rem',
	background: '#FFF',
	border: '3px solid',
	borderRadius: '50%',
})
